import React from 'react';
import EImg from './EImg';

const ESpeak = ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Speaker"
		aria-label="Emoji: Cheering megaphone"
		alt="📣"
		src="https://abs.twimg.com/emoji/v2/72x72/1f4e3.png"
	/>
);

export default ESpeak;
